import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zhTranslation from '@/locales/zh/translation.json';
import jaTranslation from '@/locales/ja/translation.json';
import summaryZhTranslation from '@/locales/zh/summary.json';
import summaryJaTranslation from '@/locales/ja/summary.json';
import { FLAGS } from './flags';

const supportedLngs = ['ja', 'zh'];

const searchParams = new URLSearchParams(window.location.search);
const langParams = searchParams.get('lang');

const lng = langParams && supportedLngs.includes(langParams) ? langParams : 'ja';

void i18n.use(initReactI18next).init({
  lng,
  fallbackLng: 'ja',
  debug: FLAGS.FEATURES_DEV.ENABLE_I18N_DEBUG,
  resources: {
    ja: {
      translation: jaTranslation,
      summary: summaryJaTranslation
    },
    zh: {
      translation: zhTranslation,
      summary: summaryZhTranslation
    }
  },
  supportedLngs,
  interpolation: {
    escapeValue: false // React 已经做了 XSS 防护，不需要 i18next 再进行转义
  }
});

// prettier-ignore
const zhIndex = [
  '〇', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十',
  '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'
];

i18n.services.formatter?.add('indexFormat', (value: unknown, lng) => {
  const index = parseInt(String(value), 10);
  if (Number.isNaN(index)) {
    return String(value);
  }

  switch (lng) {
    case 'ja': {
      if (index === 0) {
        return '⓪';
      }
      if (index <= 20) {
        return String.fromCharCode('①'.charCodeAt(0) + index - 1);
        // } else if (index <= 35) {
        //   return String.fromCharCode('㉑'.charCodeAt(0) + index - 21);
        // } else if (index <= 50) {
        //   return String.fromCharCode('㊱'.charCodeAt(0) + index - 36);
      } else {
        return index.toString();
      }
    }
    case 'zh': {
      return zhIndex[index] || index.toString();
    }
    default:
      return index.toString();
  }
});

export default i18n;
